import { useState } from "react";
import {
	getDocFormFiller,
	getDocFormFillerBySender,
} from "../../../services/templateV2Service";
import {
	deriveInitialsFromName,
	getSignerDisplayNameFromStorage,
} from "../utils/initials";

export const useDocFormFiller = () => {
	const [docFormFiller, setDocFormFiller] = useState(null);
	const [fields, setFields] = useState([]);
	const [urlPdf, setUrlPdf] = useState("");
	const [values, setValues] = useState([]);
	const [flowId, setFlowId] = useState("");

	const formatDateToMMDDYYYY = (value) => {
		if (!value) return "";

		const ymdMatch = /^(\d{4})[-/](\d{2})[-/](\d{2})(?:T.*)?$/.exec(value);
		if (ymdMatch) {
			const [, y, m, d] = ymdMatch;
			return `${m}/${d}/${y}`;
		}

		const mdyMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
		if (mdyMatch) {
			return value;
		}

		return value;
	};

	const getDocFormFillerData = async (id, formRequestId) => {
		try {
			const response = await getDocFormFiller(id, formRequestId);
			setDocFormFiller(response.data);

			if (response.data.flowId) {
				setFlowId(response.data.flowId);
			}

			const mappedFields = (response.data.new.form[0].fields || []).map(field => ({
				...field,
				id: field.fieldId,
				type: field.fieldType,
				title: field.fieldDescription || field.title || field.fieldId,
				required: field.fieldRequired,
			}));
			setFields(mappedFields);
			if(response.data.pdfUrl) {
				setUrlPdf(response.data.pdfUrl);
			} else {
				setUrlPdf(response.data.doc.thumbnail);
			}
			const signerName = getSignerDisplayNameFromStorage();
			const initialValues = (response.data.new.form[0].fields || []).map(
				(field) => {
					let value =
						field.fieldType === "date"
							? formatDateToMMDDYYYY(field.fieldValue)
							: field.fieldValue || "";
					if (
						field.fieldType === "initials" &&
						field.autoGenerateInitials &&
						!(value || "").toString().trim()
					) {
						value = deriveInitialsFromName(signerName);
					}
					return {
						id: field.fieldId,
						label: field.fieldDescription,
						placeholder: "",
						value,
						fieldType: field.fieldType,
						autoGenerateInitials: Boolean(field.autoGenerateInitials),
					};
				}
			);
			setValues(initialValues);
		} catch (error) {
			console.error("Error fetching doc form filler:", error);
			throw error;
		}
	};

	const getDocFormFillerBySenderData = async (id) => {
		try {
			const response = await getDocFormFillerBySender(id);
			setDocFormFiller(response.data);

			if (response.data.flowId) {
				setFlowId(response.data.flowId);
			}

			const mappedFields = (response.data.new.form[0].fields || []).map(field => ({
				...field,
				id: field.fieldId,
				type: field.fieldType,
				title: field.fieldDescription || field.title || field.fieldId,
				required: field.fieldRequired,
			}));
			setFields(mappedFields);
			console.log('response.data.pdfUrl', response.data.pdfUrl);
			console.log('response.data.doc.thumbnail', response.data.doc.thumbnail);
			setUrlPdf(response.data.pdfUrl || response.data.doc.thumbnail);
			const signerName = getSignerDisplayNameFromStorage();
			const initialValues = (response.data.new.form[0].fields || []).map(
				(field) => {
					let value =
						field.fieldType === "date"
							? formatDateToMMDDYYYY(field.fieldValue)
							: field.fieldValue || "";
					if (
						field.fieldType === "initials" &&
						field.autoGenerateInitials &&
						!(value || "").toString().trim()
					) {
						value = deriveInitialsFromName(signerName);
					}
					return {
						id: field.fieldId,
						label: field.fieldDescription,
						placeholder: "",
						value,
						fieldType: field.fieldType,
						autoGenerateInitials: Boolean(field.autoGenerateInitials),
					};
				}
			);
			setValues(initialValues);
		} catch (error) {
			console.error("Error fetching doc form filler:", error);
			throw error;
		}
	};

	// const rejectDocForm = async (id) => {
	// 	try {
	// 		await docFormFillerService.rejectDocForm(id);
	// 	} catch (error) {
	// 		console.error("Error rejecting doc form:", error);
	// 		throw error;
	// 	}
	// };

	// const completeDocForm = async (id) => {
	// 	try {
	// 		await docFormFillerService.completeDocForm(id);
	// 	} catch (error) {
	// 		console.error("Error completing doc form:", error);
	// 		throw error;
	// 	}
	// };

	// const updateField = async (fieldId, value) => {
	// 	try {
	// 		await docFormFillerService.updateField(fieldId, value);
	// 		setFields(prevFields =>
	// 			prevFields.map(field =>
	// 				field.id === fieldId ? { ...field, value } : field
	// 			)
	// 		);
	// 	} catch (error) {
	// 		console.error("Error updating field:", error);
	// 		throw error;
	// 	}
	// };

	// Permite actualizar el valor de un campo por id
	const setValue = (fieldId, value) => {
		setValues((prev) =>
			prev.map((f) =>
				String(f.id) === String(fieldId) ? { ...f, value } : f
			)
		);
	};

	return {
		docFormFiller,
		setDocFormFiller,
		getDocFormFillerData,
		fields,
		urlPdf,
		values,
		setUrlPdf,
		setValue,
		getDocFormFillerBySenderData,
		flowId,
	};
};
